import React, { memo } from 'react';
import styled from 'styled-components';
import { HotelResult } from 'services/BackendApi';
import SearchResultHotel from 'pureUi/SearchResultHotel';
import qs from 'qs';
import { IAvailableCurrency } from 'services/BackendApi/types/AvailableCurrenciesResponse';

export interface SearchResultListProps {
  className?: string;
  searchResults: HotelResult[];
  expandedHighlights: string[];
  selectedTa: any;
  selectedCompanyMembership: any;
  onToggleHighlights: (hotelUuid: string) => any;
  selectedCurrencyData?: IAvailableCurrency | null;
}

// eslint-disable-next-line react/display-name
export const SearchResultList = memo((props: SearchResultListProps) => {
  return (
    <div className={`search-result-list ${props.className}`}>
      {props.searchResults.map(result => {
        const urlParams = qs.parse(window.location.search.slice(1));
        if (props.selectedTa?.uuid) {
          urlParams.tauuid = props.selectedTa.uuid;
        }
        urlParams.name = result.name;
        urlParams.hotelUuid = result.uuid; // Add hotel UUID as query param
        if (props.selectedCompanyMembership) {
          urlParams.membership = props.selectedCompanyMembership.uuid;
        }

        const url = `/booking-builder?${qs.stringify(urlParams)}`;

        return (
          <SearchResultHotel
            key={result.uuid}
            result={result}
            showHighlights={props.expandedHighlights.includes(result.uuid)}
            url={url}
            onToggleHighlights={props.onToggleHighlights}
            selectedCurrencyData={props.selectedCurrencyData}
          />
        );
      })}
    </div>
  );
});

export default styled(SearchResultList)`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }
`;
